// Autogenerated file
export const bidCalculationOptionFlagsEnum = {
    None: "None",
    WithoutNotification: "WithoutNotification",
    IsPlannedBidStart: "IsPlannedBidStart",
};
export const bidCalculationOptionFlags = [
    { label: "Без опций", value: "None", intValue: 0 },
    { label: "Без уведомлений", value: "WithoutNotification", intValue: 1 },
    { label: "Запуск запланированной заявки", value: "IsPlannedBidStart", intValue: 2 },
];
